module.exports = __webpack_public_path__ + "static/media/propel-icon-white.db4cbc2c.svg";